export default "__VITE_ASSET__8e2fe6ca__"